import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard } from 'lucide-react';
import { trackAddToCart } from '../utils/fbPixel';
interface CtaButtonProps {
  className?: string;
}
export function CtaButton({
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    trackAddToCart();
  };
  return <div className={`flex flex-col items-center w-full max-w-xl mx-auto ${className}`} data-id="element-1">
      <motion.a href="https://pay.hotmart.com/V104805894A" target="_blank" rel="noopener noreferrer" onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="w-full bg-[#E8820C] hover:bg-[#d1750a] text-white font-bold text-lg sm:text-xl py-4 px-6 rounded-xl shadow-[0_8px_20px_rgba(232,130,12,0.4)] transition-colors duration-300 flex items-center justify-center text-center border-b-4 border-[#b86608] no-underline" data-id="element-2">
        👉 SÍ, QUIERO MI PROTOCOLO RESETEO 21D — ACCESO INMEDIATO POR $6.39
      </motion.a>

      <div className="flex items-center justify-center gap-4 mt-4 text-[#2D1B06]/70 text-sm font-medium" data-id="element-3">
        <div className="flex items-center" data-id="element-4">
          <ShieldCheck className="w-4 h-4 mr-1 text-green-600" data-id="element-5" />
          <span data-id="element-6">Pago 100% Seguro</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-7">
          <CreditCard className="w-4 h-4" data-id="element-8" />
          <span data-id="element-9">Tarjetas & PayPal</span>
        </div>
      </div>
    </div>;
}